import React, { useEffect, useState } from "react";
import "./SideBar.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from "../../images/icons/NDashboard.png";
import MemberIcon from "../../images/icons/NMember.png";
import BlogIcon from "../../images/icons/N_Blog.png";
import ProductIcon from "../../images/icons/N_Menu.png";
import PromotionIcon from "../../images/icons/N_Promotion.png";
import NotiIcon from "../../images/icons/N_Notification.png";
import TireIcon from "../../images/icons/NTire.png";
import ReportIcon from "../../images/icons/N_Report.png";
import OrgIcon from "../../images/icons/N_Org.png";
import brandIcon from "../../images/icons/N_brand.png";
import branchIcon from "../../images/icons/N_branch.png";
import SettingIcon from "../../images/icons/NSetting.png";
import UserMangementIcon from "../../images/icons/NUserManagement.png";
import HelpCenterIcon from "../../images/icons/NHelpCenter.png";
import RewardIcon from "../../images/icons/NReward.png";
import Dashboard_Active from "../../images/icons/NDashboard_Active.png";
import Member_Active from "../../images/icons/n_member_active.png";
import Blog_Active from "../../images/icons/N_Blog_active.png";
import Reward_Active from "../../images/icons/NReward_Active.png";
import Reserve_Active from "../../images/icons/Reserve_Active.png";
import Product_Active from "../../images/icons/Menu_Active.png";
import Promotion_Active from "../../images/icons/N_Promotion_Active.png";
import Noti_Active from "../../images/icons/N_Noti_Active.png";
import Tire_Active from "../../images/icons/NTire_Active.png";
import Org_Active from "../../images/icons/N_Org_active.png";
import branch_Active from "../../images/icons/N_branch_active.png";
import brand_Active from "../../images/icons/N_brand_active.png";
import defaultLogo from "../../images/defaultLogo.png";
import logout from "../../images/icons/logout.png";
import Reserve from "../../images/icons/Reserve.png";
import dropdown_arrow from "../../images/icons/NDropdown.png";
import dropup_arrow from "../../images/icons/NDropup.png";
import api from "../../api/api";
import apiUtil from "../../api/apiUtil";
import getToken from "../../pages/getToken";

const SideBar = (props) => {
  const isShowSideBar = props.isShowSideBar;
  const [activeTab, setActiveTab] = useState(null);
  const [userManagementDropdown, setUserManagementDropdown] = useState(false);
  const [helpCenterDropdown, setHelpCenterDropdown] = useState(false);
  const [settingsDropdown, setSettingsDropdown] = useState(false);
  const [reportDropdown, setReportDropdown] = useState(false);
  const [logoImage, setLogoImage] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const navigate = useNavigate();

  let orgLevel = localStorage.getItem("orgLevel");
  let brandId = localStorage.getItem("brandId");
  const userData = JSON.parse(localStorage.getItem("user"));

  // console.log("orgLevel: " + orgLevel);
  useEffect(() => {
    getLogoImage();
  }, []);
  const getLogoImage = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "Logo" }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              location.href = "/login";
            } else if (response.data.code === 200) {
              setLogoImage(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            setLogoImage([]);
            console.log(error);
          }
        )
      );
  };

  const hideDropdown = () => {
    setUserManagementDropdown(false);
    setReportDropdown(false);
    setHelpCenterDropdown(false);
    setSettingsDropdown(false);
  };
  useEffect(() => {
    getAdminInfo();
  }, []);

  const getAdminInfo = () => {
    const param = {
      userId: userData.userId,
      brandId: brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            localStorage.removeItem("orgLevel");
            location.href = "/login";
          } else if (response.data.code === 200) {
            setModuleList(response.data.data.adminModules);
            // handleRedirection(response.data.data.adminModules);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const handleRedirection = (moduleList) => {
    for (const action of moduleActions) {
      const module = moduleList.find(
        (module) => module.name === action.name && module.accessLevel === 4
      );
      if (module) {
        if (action.route) navigate(action.route);
        if (action.tab) setActiveTab(action.tab);
        hideDropdown();
        return;
      }
    }
  };
  const moduleActions = [
    { name: "Dashboard", route: "/dashboard", tab: "Dashboard" },
  ];
  const location = useLocation();

  useEffect(() => {
    const pathToTabMapping = {
      dashboard: "Dashboard",
      member: "Member",
      blog: "Blog",
      product: "Product",
      reward: "Reward (Panel & Mobile)",
      "reward/customer": "Reward (Panel & Mobile)",
      reserve: "Reserve (Panel & Mobile)",
      promotion: "Promotion",
      announcement: "Notification",
      tier: "Tire",
      organization: "Organization",
      brand: "Brand",
      branch: "Branch",
      "report/add": "Add",
      "report/withdraw": "Withdraw",
      "report/reserve-report": "ReserveReport",
      "report/member-report": "MemberReport",
      "settings/admin-panel-settings": "AdminPanelSettings",
      "settings/mobile-settings": "MobileSettings",
      "user-management/role": "Role",
      "user-management/users": "Users",
      "help-center/contact-us": "Contact",
      "help-center/faq": "FAQ",
      "privacy-policy": "Privacy",
    };

    const path = location.pathname.replace(/^\//, "");
    const tab = pathToTabMapping[path];

    if (tab) {
      setActiveTab(tab);
      hideDropdown();

      if (
        tab === "Add" ||
        tab === "Withdraw" ||
        tab === "ReserveReport" ||
        tab === "MemberReport"
      ) {
        setReportDropdown(true);
      } else if (tab === "AdminPanelSettings" || tab === "MobileSettings") {
        setSettingsDropdown(true);
      } else if (tab === "Role" || tab === "Users") {
        setUserManagementDropdown(true);
      } else if (tab === "Contact" || tab === "FAQ") {
        setHelpCenterDropdown(true);
      }
    }
  }, [location.pathname]);

  const getActiveTab = (tabName, activeTab) => {
    return activeTab === tabName ? "activeItem" : "menuItem";
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setActiveTab(true);
    }
  };
  const toggleSidebar = (openIcon, closeIcon) => {
    return props.isShowSideBar ? openIcon : closeIcon;
  };

  const iconSources = {
    Dashboard: () =>
      activeTab === "Dashboard" ? Dashboard_Active : DashboardIcon,
    Member: () => (activeTab === "Member" ? Member_Active : MemberIcon),
    Blog: () => (activeTab === "Blog" ? Blog_Active : BlogIcon),
    Reward: () =>
      activeTab === "Reward (Panel & Mobile)" ? Reward_Active : RewardIcon,
    Reserve: () =>
      activeTab === "Reserve (Panel & Mobile)" ? Reserve_Active : Reserve,
    Product: () => (activeTab === "Product" ? Product_Active : ProductIcon),
    Promotion: () =>
      activeTab === "Promotion" ? Promotion_Active : PromotionIcon,
    Notification: () => (activeTab === "Notification" ? Noti_Active : NotiIcon),
    Tire: () => (activeTab === "Tire" ? Tire_Active : TireIcon),
    Organization: () => (activeTab === "Organization" ? Org_Active : OrgIcon),
    Brand: () => (activeTab === "Brand" ? brand_Active : brandIcon),
    Branch: () => (activeTab === "Branch" ? branch_Active : branchIcon),
  };

  return (
    <div className={toggleSidebar("NavBar", "NavBar NavBarIcon")}>
      <img
        src={logoImage.valueInText ? logoImage.valueInText : defaultLogo}
        className={`BIMLogo ${logoImage.valueInText ?? 'animated'}`}
        alt="BIM_logo"
      />
      <div className="position-relative scrollbar">
        <ul className="sidebar-menu">
          {moduleList.some(
            (module) => module.name == "Dashboard" && module.accessLevel == 4
          ) && (
              <Link to="/dashboard">
                <li
                  className={getActiveTab("Dashboard", activeTab)}
                  onClick={() => setActiveTab("Dashboard")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Dashboard"]()}
                      className="nav_Icon"
                      alt="dashboard_icon"
                    />
                    {isShowSideBar && <span>Dashboard</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name == "Member" && module.accessLevel == 4
          ) && (
              <Link to="/member">
                <li
                  className={getActiveTab("Member", activeTab)}
                  onClick={() => setActiveTab("Member")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Member"]()}
                      className="nav_Icon"
                      alt="member_icon"
                    />
                    {isShowSideBar && <span>Member</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name == "Blog" && module.accessLevel == 4
          ) && (
              <Link to="/blog">
                <li
                  className={getActiveTab("Blog", activeTab)}
                  onClick={() => setActiveTab("Blog")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Blog"]()}
                      className="nav_Icon"
                      alt="blog_icon"
                    />
                    {isShowSideBar && <span>Blog</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) =>
              module.name == "Reward (Panel & Mobile)" &&
              module.accessLevel == 4
          ) && (
              <Link to="/reward">
                <li
                  className={getActiveTab("Reward (Panel & Mobile)", activeTab)}
                  onClick={() => setActiveTab("Reward (Panel & Mobile)")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Reward"]()}
                      className="nav_Icon"
                      alt="reward_icon"
                    />
                    {isShowSideBar && <span>Reward</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) =>
              module.name === "Reserve (Panel & Mobile)" &&
              module.accessLevel == 4
          ) && (
              <Link to="/reserve">
                <li
                  className={getActiveTab("Reserve (Panel & Mobile)", activeTab)}
                  onClick={() => setActiveTab("Reserve (Panel & Mobile)")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Reserve"]()}
                      className="nav_Icon"
                      alt="reserve_icon"
                    />
                    {isShowSideBar && <span>Reserve</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Menu" && module.accessLevel == 4
          ) && (
              <Link to="/product">
                <li
                  className={getActiveTab("Product", activeTab)}
                  onClick={() => setActiveTab("Product")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Product"]()}
                      className="nav_Icon"
                      alt="product_icon"
                    />
                    {isShowSideBar && orgLevel == 1 && <span>Room</span>}
                    {isShowSideBar && orgLevel == 2 && <span>Service</span>}
                    {isShowSideBar && orgLevel == 3 && <span>Menu</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Promotion" && module.accessLevel == 4
          ) && (
              <Link to="/promotion">
                <li
                  className={getActiveTab("Promotion", activeTab)}
                  onClick={() => setActiveTab("Promotion")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Promotion"]()}
                      className="nav_Icon"
                      alt="promotion_icon"
                    />
                    {isShowSideBar && <span>Promotion</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) =>
              module.name === "Notification" && module.accessLevel == 4
          ) && (
              <Link to="/announcement">
                <li
                  className={getActiveTab("Notification", activeTab)}
                  onClick={() => setActiveTab("Notification")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Notification"]()}
                      className="nav_Icon"
                      alt="notification_icon"
                    />
                    {isShowSideBar && <span>Announcement</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Tier Level" && module.accessLevel == 4
          ) && (
              <Link to="/tier">
                <li
                  className={getActiveTab("Tire", activeTab)}
                  onClick={() => setActiveTab("Tire")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Tire"]()}
                      className="nav_Icon"
                      alt="tire_icon"
                    />
                    {isShowSideBar && <span>Tier Level</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) =>
              module.name === "Organization" && module.accessLevel == 4
          ) && (
              <Link to="/organization">
                <li
                  className={getActiveTab("Organization", activeTab)}
                  onClick={() => setActiveTab("Organization")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Organization"]()}
                      className="nav_Icon"
                      alt="org_icon"
                    />
                    {isShowSideBar && <span>Organization</span>}
                  </div>
                </li>
              </Link>
            )}
          {moduleList.some(
            (module) => module.name === "Brand" && module.accessLevel == 4
          ) && (
              <Link to="/brand">
                <li
                  className={getActiveTab("Brand", activeTab)}
                  onClick={() => setActiveTab("Brand")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Brand"]()}
                      className="nav_Icon"
                      alt="brand_icon"
                    />
                    {isShowSideBar && <span>Brand</span>}
                  </div>
                </li>
              </Link>
            )}
          {moduleList.some(
            (module) => module.name === "Branch" && module.accessLevel == 4
          ) && (
              <Link to="/branch">
                <li
                  className={getActiveTab("Branch", activeTab)}
                  onClick={() => setActiveTab("Branch")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Branch"]()}
                      className="nav_Icon"
                      alt="branch_icon"
                    />
                    {isShowSideBar && <span>Branch</span>}
                  </div>
                </li>
              </Link>
            )}
          {moduleList.some(
            (module) => module.name == "Report" && module.accessLevel == 4
          ) && (
              <>
                <li
                  className="menuItem"
                  onClick={() => {
                    if (
                      location.pathname.includes("report/point") ||
                      location.pathname.includes("report/add") ||
                      location.pathname.includes("report/withdraw") ||
                      location.pathname.includes("report/reserve-report") ||
                      location.pathname.includes("report/member-report")
                    ) {
                      setReportDropdown(!reportDropdown);
                      setActiveTab("PointReport");
                    } else {
                      setReportDropdown(true);
                      navigate("/report/point");
                      setActiveTab("PointReport");
                    }
                  }}
                  onKeyDown={handleKeyDown}
                >
                  <div
                    className={`helpCenterNavLink ${toggleSidebar(
                      "navLink",
                      "navIcon"
                    )}`}
                  >
                    <img src={ReportIcon} className="nav_Icon" alt="ReportIcon" />
                    {isShowSideBar ? (
                      <>
                        <span>Report</span>
                        {reportDropdown ? (
                          <img
                            src={dropup_arrow}
                            className="imgDropdownupArrow"
                            alt="dropup_arrow"
                          />
                        ) : (
                          <img
                            src={dropdown_arrow}
                            className="imgDropdownupArrow"
                            alt="dropdown_arrow"
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </li>
                {reportDropdown && (
                  <>
                    <Link to="/report/point">
                      <li
                        className={getActiveTab("PointReport", activeTab)}
                        onClick={() => setActiveTab("PointReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Point Report</span>}
                        </div>
                      </li>
                    </Link>

                    <Link to="/report/add">
                      <li
                        className={getActiveTab("Add", activeTab)}
                        onClick={() => setActiveTab("Add")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Point Add</span>}
                        </div>
                      </li>
                    </Link>

                    <Link to="/report/withdraw">
                      <li
                        className={getActiveTab("Withdraw", activeTab)}
                        onClick={() => setActiveTab("Withdraw")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Point Withdraw</span>}
                        </div>
                      </li>
                    </Link>

                    <Link to="/report/reserve-report">
                      <li
                        className={getActiveTab("ReserveReport", activeTab)}
                        onClick={() => setActiveTab("ReserveReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Reserve Report</span>}
                        </div>
                      </li>
                    </Link>
                    <Link to="/report/member-report">
                      <li
                        className={getActiveTab("MemberReport", activeTab)}
                        onClick={() => setActiveTab("MemberReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Member Report</span>}
                        </div>
                      </li>
                    </Link>
                  </>
                )}
              </>
            )}
          {moduleList.some(
            (module) => module.name === "Roles" && module.accessLevel == 4
          ) &&
            moduleList.some(
              (module) => module.name === "Users" && module.accessLevel === 4
            ) && (
              <>
                <li
                  className="menuItem"
                  onClick={() => {
                    if (
                      location.pathname.includes("user-management/role") ||
                      location.pathname.includes("user-management/users")
                    ) {
                      setUserManagementDropdown(!userManagementDropdown);
                      setActiveTab("Role");
                    } else {
                      setUserManagementDropdown(true);
                      navigate("/user-management/role");
                      setActiveTab("Role");
                    }
                  }}
                  onKeyDown={handleKeyDown}
                >
                  <div
                    className={`userManagementNavLink ${toggleSidebar(
                      "navLink",
                      "navIcon"
                    )}`}
                  >
                    <img
                      src={UserMangementIcon}
                      className="nav_Icon"
                      alt="userManagementIcon"
                    />
                    {isShowSideBar ? (
                      <>
                        <span>User Management</span>
                        {userManagementDropdown ? (
                          <img
                            src={dropup_arrow}
                            className="imgDropdownupArrow"
                            alt="dropup_arrow"
                          />
                        ) : (
                          <img
                            src={dropdown_arrow}
                            className="imgDropdownupArrow"
                            alt="dropdown_arrow"
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </li>
                {userManagementDropdown && (
                  <>
                    {moduleList.some(
                      (module) =>
                        module.name === "Roles" && module.accessLevel == 4
                    ) && (
                        <Link to="/user-management/role">
                          <li
                            className={getActiveTab("Role", activeTab)}
                            onClick={() => setActiveTab("Role")}
                            onKeyDown={handleKeyDown}
                          >
                            <div className={toggleSidebar("navLink", "navIcon")}>
                              {toggleSidebar && <span>Role</span>}
                            </div>
                          </li>
                        </Link>
                      )}

                    {moduleList.some(
                      (module) =>
                        module.name === "Users" && module.accessLevel == 4
                    ) && (
                        <Link to="/user-management/users">
                          <li
                            className={getActiveTab("Users", activeTab)}
                            onClick={() => setActiveTab("Users")}
                            onKeyDown={handleKeyDown}
                          >
                            <div className={toggleSidebar("navLink", "navIcon")}>
                              {toggleSidebar && <span>User</span>}
                            </div>
                          </li>
                        </Link>
                      )}
                  </>
                )}
              </>
            )}

          {moduleList.some(
            (module) => module.name == "FAQ" && module.accessLevel == 4
          ) && (
              <>
                <li
                  className="menuItem"
                  onClick={() => {
                    if (
                      location.pathname.includes("help-center/contact-us") ||
                      location.pathname.includes("help-center/faq")
                    ) {
                      setHelpCenterDropdown(!helpCenterDropdown);
                      setActiveTab("Contact");
                    } else {
                      setHelpCenterDropdown(true);
                      navigate("/help-center/contact-us");
                      setActiveTab("Contact");
                    }
                  }}
                  onKeyDown={handleKeyDown}
                >
                  <div
                    className={`helpCenterNavLink ${toggleSidebar(
                      "navLink",
                      "navIcon"
                    )}`}
                  >
                    <img
                      src={HelpCenterIcon}
                      className="nav_Icon"
                      alt="helpCenterIcon"
                    />
                    {isShowSideBar ? (
                      <>
                        <span>Help Center</span>
                        {helpCenterDropdown ? (
                          <img
                            src={dropup_arrow}
                            className="imgDropdownupArrow"
                            alt="dropup_arrow"
                          />
                        ) : (
                          <img
                            src={dropdown_arrow}
                            className="imgDropdownupArrow"
                            alt="dropdown_arrow"
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </li>
                {helpCenterDropdown && (
                  <>
                    <Link to="/help-center/contact-us">
                      <li
                        className={getActiveTab("Contact", activeTab)}
                        onClick={() => setActiveTab("Contact")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Contact Us</span>}
                        </div>
                      </li>
                    </Link>

                    <Link to="/help-center/faq">
                      <li
                        className={getActiveTab("FAQ", activeTab)}
                        onClick={() => setActiveTab("FAQ")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>FAQ</span>}
                        </div>
                      </li>
                    </Link>
                  </>
                )}
              </>
            )}

          {moduleList.some(
            (module) => module.name === "Setting" && module.accessLevel == 4
          ) && (
              <>
                <li
                  className="menuItem"
                  onClick={() => {
                    if (
                      location.pathname.includes(
                        "settings/admin-panel-settings"
                      ) ||
                      location.pathname.includes("settings/mobile-settings")
                    ) {
                      setSettingsDropdown(!settingsDropdown);
                      setActiveTab("AdminPanelSettings");
                    } else {
                      setSettingsDropdown(true);
                      navigate("/settings/admin-panel-settings");
                      setActiveTab("AdminPanelSettings");
                    }
                  }}
                  onKeyDown={handleKeyDown}
                >
                  <div
                    className={`settingsNavLink  ${toggleSidebar(
                      "navLink",
                      "navIcon"
                    )}`}
                  >
                    <img
                      src={SettingIcon}
                      className="nav_Icon"
                      alt="settingsIcon"
                    />
                    {isShowSideBar ? (
                      <>
                        <span>Setting</span>
                        {settingsDropdown ? (
                          <img
                            src={dropup_arrow}
                            className="imgDropdownupArrow"
                            alt="dropup_arrow"
                          />
                        ) : (
                          <img
                            src={dropdown_arrow}
                            className="imgDropdownupArrow"
                            alt="dropdown_arrow"
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </li>
                {settingsDropdown && (
                  <>
                    <Link to="/settings/admin-panel-settings">
                      <li
                        className={
                          activeTab === "AdminPanelSettings"
                            ? "activeItem"
                            : "menuItem"
                        }
                        onClick={() => setActiveTab("AdminPanelSettings")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Admin Panel</span>}
                        </div>
                      </li>
                    </Link>

                    <Link to="/settings/mobile-settings">
                      <li
                        className={getActiveTab("MobileSettings", activeTab)}
                        onClick={() => setActiveTab("MobileSettings")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>Mobile</span>}
                        </div>
                      </li>
                    </Link>
                  </>
                )}
              </>
            )}
        </ul>
      </div>
      <ul className={`position-relative ${toggleSidebar("", "hideNavIcon")}`}>
        <Link to="/login">
          <li
            onClick={() => localStorage.removeItem("user")}
            className="logOut-container menuItem"
            onKeyDown={handleKeyDown}
          >
            <div className="Logout_button navLink text-center">
              <img src={logout} className="nav_Icon" alt="logout_icon" />
              {isShowSideBar ? <span className="logout">Log out</span> : <></>}
            </div>
          </li>
        </Link>
      </ul>
    </div>
  );
};

export default SideBar;
